export const artworkNavQuery = `
  decades(first: 50) {
    nodes {
      __typename
      description
      name
      slug
    }
  }
  artworkTypes(first: 50) {
    nodes {
      __typename
      description
      name
      slug
    }
  }
  movements(first: 50) {
    nodes {
      __typename
      description
      name
      slug
    }
  }
  specialCollections(first: 50) {
    nodes {
      __typename
      description
      name
      slug
    }
  }
  sites(first: 50) {
    nodes {
      __typename
      description
      name
      slug
    }
  }
`;
